import React, { forwardRef } from "react";
import { BSAnchor } from "../../types";

export const NavbarBrand = forwardRef<HTMLAnchorElement, BSAnchor>(
  ({ children, className = "", component: Component = "a", ...props }, ref) => (
    <Component {...props} className={`navbar-brand ${className}`} ref={ref}>
      {children}
    </Component>
  )
);